<div class="card" style="position: relative">
    <p-toast></p-toast>
    <span class="page-title"><i class="pi pi-wallet page-title-icon"></i>Agent Daily Collections</span>
    <div class="info-banner mt-2">
        <i class="pi pi-info-circle info-banner-icon"></i>
        <small>Record payments collected by agents outside of the POS system — such as cash, mobile money, or bank deposits. These collections are matched against imported bank statements during reconciliation.</small>
    </div>
    <div class="mt-6">

        <div class="grid">
            <div class="col-12 md:col-5">
                <div class="card shadow-1">
                    <h6 class="font-semibold mb-3"><i class="pi pi-plus-circle mr-2"></i>Record Collection</h6>

                    <div class="collection-form">
                    <div class="field">
                        <label class="ctrl-label">Transaction Date <span class="text-red-500">*</span></label>
                        <p-calendar [(ngModel)]="transactionDate" [showIcon]="true"
                            dateFormat="dd/mm/yy" [maxDate]="today"
                            placeholder="Select date" styleClass="w-full"></p-calendar>
                    </div>

                    <div class="field">
                        <label class="ctrl-label">Transaction Source <span class="text-red-500">*</span></label>
                        <p-dropdown [options]="transactionSources" [(ngModel)]="transactionSource"
                            placeholder="Select Source" optionLabel="label" optionValue="value"
                            styleClass="w-full"></p-dropdown>
                    </div>
                    <div class="field">
                        <label class="ctrl-label">Payment Amount <span class="text-red-500">*</span></label>
                        <p-inputNumber [(ngModel)]="paymentAmount" placeholder="0.00"
                            mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
                            [min]="0" styleClass="w-full"></p-inputNumber>
                    </div>

                    <div class="field">
                        <label class="ctrl-label">Currency <span class="text-red-500">*</span></label>
                        <p-dropdown [options]="currencies()" [(ngModel)]="currencyId"
                            placeholder="Select Currency" optionLabel="code" optionValue="id"
                            [loading]="loadingCurrencies()" styleClass="w-full"></p-dropdown>
                    </div>

                    <div class="field">
                        <label class="ctrl-label">Reference <span class="text-red-500">*</span></label>
                        <span class="p-input-icon-left w-full">
                            <i class="pi pi-tag"></i>
                            <input pInputText [(ngModel)]="reference" placeholder="Transaction reference" class="w-full" />
                        </span>
                    </div>

                    <div class="field">
                        <label class="ctrl-label">Description <span class="text-red-500">*</span></label>
                        <span class="p-input-icon-left w-full">
                            <i class="pi pi-align-left"></i>
                            <input pInputText [(ngModel)]="description" placeholder="Description" class="w-full" />
                        </span>
                    </div>

                    </div><!-- /collection-form -->

                    <div class="flex justify-content-end mt-3">
                        <p-button label="Submit Collection" icon="pi pi-check"
                            [disabled]="!isFormValid() || submitting()"
                            [loading]="submitting()"
                            (onClick)="submit()"
                            [text]="true" [raised]="true" severity="success">
                        </p-button>
                    </div>
                </div>
            </div>

            <div class="col-12 md:col-7">
                <div class="card shadow-1">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <h6 class="font-semibold mb-0"><i class="pi pi-history mr-2"></i>Collection History</h6>
                        <p-button icon="pi pi-refresh" [text]="true" (onClick)="loadHistory()"
                            [loading]="loadingHistory()" pTooltip="Refresh"></p-button>
                    </div>
                    <!-- Desktop table -->
                    <div class="desktop-only">
                        <p-table [value]="history()" styleClass="p-datatable-sm p-datatable-striped"
                            [loading]="loadingHistory()" [paginator]="true" [rows]="10" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Date</th>
                                    <th>Source</th>
                                    <th>Reference</th>
                                    <th>Credit</th>
                                    <th>Currency</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rec>
                                <tr>
                                    <td>{{ rec.transactionDate | date:'dd MMM yyyy' }}</td>
                                    <td>
                                        <p-tag [value]="rec.transactionSource"
                                            [severity]="getSourceSeverity(rec.transactionSource)"></p-tag>
                                    </td>
                                    <td>{{ rec.reference }}</td>
                                    <td>{{ rec.credit | number:'1.2-2' }}</td>
                                    <td>{{ rec.currency?.code }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="5" class="text-center p-4 text-color-secondary">No collections recorded yet.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <!-- Mobile card view -->
                    <div class="mobile-only">
                        <div *ngIf="loadingHistory()" class="flex justify-content-center py-4">
                            <p-progressSpinner strokeWidth="4" [style]="{ width: '36px', height: '36px' }"></p-progressSpinner>
                        </div>
                        <ng-container *ngIf="!loadingHistory()">
                            <div *ngIf="history().length === 0" class="text-center text-color-secondary p-4">
                                No collections recorded yet.
                            </div>
                            <div class="recon-card-list">
                                <div *ngFor="let rec of history()" class="recon-card">
                                    <div class="recon-card-header">
                                        <span class="recon-card-date">{{ rec.transactionDate | date:'dd MMM yyyy' }}</span>
                                        <p-tag [value]="rec.transactionSource"
                                            [severity]="getSourceSeverity(rec.transactionSource)"></p-tag>
                                    </div>
                                    <div class="recon-card-row" *ngIf="rec.reference">
                                        <span class="recon-card-label">Reference</span>
                                        <span class="recon-card-value">{{ rec.reference }}</span>
                                    </div>
                                    <div class="recon-card-amounts recon-card-amounts--two-col">
                                        <div class="recon-card-amount-item">
                                            <span class="recon-card-label">Credit</span>
                                            <span class="recon-card-value font-semibold">{{ rec.credit | number:'1.2-2' }}</span>
                                        </div>
                                        <div class="recon-card-amount-item">
                                            <span class="recon-card-label">Currency</span>
                                            <span class="recon-card-value">{{ rec.currency?.code }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
